import datepickerEn from './datepicker/en.json';
import datepickerZhHant from './datepicker/zh-Hant.json';
import datepickerVi from './datepicker/vi.json';
import datepickerTh from './datepicker/th.json';

export default {
  en: datepickerEn,
  'zh-Hant': datepickerZhHant,
  vi: datepickerVi,
  th: datepickerTh,
};
